function pad(number) {
  if (number < 10) {
    return "0" + number;
  }
  return number;
}

export const getIsoDate = (date) => {
  const year = pad(date.getUTCFullYear());
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());
  return `${year}-${month}-${day}-${hours}_${minutes}_${seconds}`;
};

export const getToDayDate = () => {
  const date = new Date();
  const day = date.getDay();
  const weekMap = {
    0: "Domingo",
    1: "Lunes",
    2: "Martes",
    3: "Miercoles",
    4: "Jueves",
    5: "Viernes",
    6: "Sabado",
  };
  return `${weekMap[day]} ${date.getDate()}`;
};
